import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d26e67a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-panel" }
const _hoisted_2 = { class: "search-panel__main" }
const _hoisted_3 = {
  key: 0,
  class: "title_green"
}
const _hoisted_4 = {
  key: 1,
  class: "title_green"
}
const _hoisted_5 = { class: "filters-container" }
const _hoisted_6 = { class: "search-panel__profiles" }
const _hoisted_7 = { class: "search-panel__appearance" }
const _hoisted_8 = { class: "search-panel__location" }
const _hoisted_9 = { class: "search-panel__additional-options" }
const _hoisted_10 = { class: "search-panel__search" }

import { onMounted, Ref, ref } from "vue";
import SearchBySection from "@/searchSection/components/SearchPanel/SearchBySection.vue";
import SearchByPhysicalData from "@/searchSection/components/SearchPanel/SearchByPhysicalData.vue";
import PriceBlock from "@/searchSection/components/SearchPanel/PriceBlock.vue";
import ProfileBlock from "@/searchSection/components/SearchPanel/ProfileBlock.vue";
import AppearanceBlock from "@/searchSection/components/SearchPanel/AppearanceBlock.vue";
import LocationBlock from "@/searchSection/components/SearchPanel/LocationBlock.vue";
import AdditionalOptionsBlock from "@/searchSection/components/SearchPanel/AdditionalOptionsBlock.vue";
import pButton from '@/common/pButton/pButton.vue'
import { useSearchStore } from "@/searchSection/store/searchStore";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";
import { useResultsStore } from "@/searchSection/store/resultsStore";
import ArrowIcon from "@/common/icons/ArrowIcon.vue";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPanel',
  setup(__props) {

const searchStore = useSearchStore()
const resultsStore = useResultsStore()

const visibleFiltersSection: Ref<boolean> = ref(true)
const visibleFiltersProfiles: Ref<boolean> = ref(true)
const visibleFiltersAppearance: Ref<boolean> = ref(true)
const visibleFiltersLocation: Ref<boolean> = ref(true)
const visibleFiltersAdditionalOptions: Ref<boolean> = ref(true)

async function searchProfiles(): Promise<void> {
  try {
    visibleFiltersAdditionalOptions.value = false

    resultsStore.setResultsLoading(true)
    const cards: ProfileCardInterface[] = await searchStore.searchProfiles()
    resultsStore.setResults(cards)
    setTimeout(() => {
        document.querySelector('.search-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 300)
  } catch (e: unknown) {
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 400) {
        window.showNotification(e.response.data?.error?.message || 'Произошла ошибка!', 'error')
      } else {
        window.showNotification('Произошла ошибка на сервере!', 'error')
      }
    } else {
      window.showNotification('Произошла непредвиденная ошибка!', 'error')
    }
  } finally {
    resultsStore.setResultsLoading(false)
  }
}

onMounted(() => {
  searchStore.setDefaultOptions()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "search-panel__title title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleFiltersSection.value = !visibleFiltersSection.value))
      }, [
        _createTextVNode(" Поиск в разделах "),
        (_unref(searchStore).filtersSection)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Указаны " + _toDisplayString(_unref(searchStore).filtersSection) + " параметр ", 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "Не указаны")),
        _createVNode(ArrowIcon, {
          class: _normalizeClass(["title__arrow", { 'title__arrow_active': visibleFiltersSection.value }])
        }, null, 8 /* PROPS */, ["class"])
      ]),
      _createVNode(SearchBySection),
      _createVNode(_Transition, {
        name: "fade-slide",
        persisted: ""
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createVNode(SearchByPhysicalData),
            _createVNode(PriceBlock)
          ], 512 /* NEED_PATCH */), [
            [_vShow, visibleFiltersSection.value]
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ProfileBlock, {
        visibleFiltersProfiles: visibleFiltersProfiles.value,
        onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (visibleFiltersProfiles.value = !visibleFiltersProfiles.value))
      }, null, 8 /* PROPS */, ["visibleFiltersProfiles"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(AppearanceBlock, {
        visibleFiltersAppearance: visibleFiltersAppearance.value,
        onToggleFilter: _cache[2] || (_cache[2] = ($event: any) => (visibleFiltersAppearance.value = !visibleFiltersAppearance.value))
      }, null, 8 /* PROPS */, ["visibleFiltersAppearance"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(LocationBlock, {
        visibleFiltersLocation: visibleFiltersLocation.value,
        onToggleFilter: _cache[3] || (_cache[3] = ($event: any) => (visibleFiltersLocation.value = !visibleFiltersLocation.value))
      }, null, 8 /* PROPS */, ["visibleFiltersLocation"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(AdditionalOptionsBlock, {
        visibleFiltersAdditionalOptions: visibleFiltersAdditionalOptions.value,
        onToggleFilter: _cache[4] || (_cache[4] = ($event: any) => (visibleFiltersAdditionalOptions.value = !visibleFiltersAdditionalOptions.value))
      }, null, 8 /* PROPS */, ["visibleFiltersAdditionalOptions"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(pButton, {
        class: "search-panel__reset",
        onClick: _unref(searchStore).resetOptions
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Сбросить все параметры ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(pButton, {
        class: "search-panel__search-btn",
        onClick: searchProfiles
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Искать ")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})